import { UIMatch } from 'react-router-dom'
import { useProjectData } from 'Features/Projects/Scenarios/Scenarios.data'

/**
 * Crumbs whose label is data rather than a constant. Both read the
 * `project-details` query the project pages already run, so the trail costs
 * no extra request once a page has loaded; until then it shows an ellipsis,
 * never the raw id.
 */
const ProjectCrumb = ({ projectId }: { projectId?: string }) => {
  const { data } = useProjectData(projectId)
  return <>{data?.projectName ?? '…'}</>
}

const ScenarioCrumb = ({
  projectId,
  scenarioId,
}: {
  projectId?: string
  scenarioId?: string
}) => {
  const { data } = useProjectData(projectId)
  const scenario = data?.scenariosList?.find(
    (item) => String(item.scenarioId) === String(scenarioId)
  )
  return <>{scenario?.scenarioName ?? '…'}</>
}

export const projectCrumb = (match: UIMatch) => (
  <ProjectCrumb projectId={match.params.projectId} />
)

export const scenarioCrumb = (match: UIMatch) => (
  <ScenarioCrumb
    projectId={match.params.projectId}
    scenarioId={match.params.scenarioId}
  />
)
